import { Fancybox } from "@fancyapps/ui";
import Inputmask from "inputmask";

document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("request");
    const triggers = document.querySelectorAll(".modal-trigger");

    if (!form || !triggers.length) {
        return;
    }

    const phoneInput = form.querySelector("#demo_tel");
    const submitButton = form.querySelector("button[type=\"submit\"]");
    const successMessage = form.querySelector(".request__success");
    const errorMessage = form.querySelector(".request__error");
    let isSubmitting = false;

    form.setAttribute("novalidate", "true");

    const initializeInputMask = () => {
        if (!phoneInput || phoneInput.inputmask) {
            return;
        }

        new Inputmask({
            mask: "+1 (999) 999-9999",
            showMaskOnHover: false,
            showMaskOnFocus: true,
            placeholder: " ",
        }).mask(phoneInput);
    };

    const validateForm = () => {
        let isValid = true;

        form.querySelectorAll("input").forEach(input => {
            const inputIsValid = input === phoneInput && input.inputmask
                ? input.inputmask.isComplete()
                : input.checkValidity();

            input.classList.toggle("invalid", !inputIsValid);
            isValid = inputIsValid && isValid;
        });

        return isValid;
    };

    const updateTextarea = textarea => {
        const maxLength = textarea.getAttribute("maxlength");
        const counter = textarea.nextElementSibling;

        if (counter && maxLength) {
            counter.textContent = `${textarea.value.length} / ${maxLength}`;
        }

        if (window.innerWidth < 768) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    const clearMessages = () => {
        successMessage?.classList.remove("display");

        if (errorMessage) {
            errorMessage.textContent = "";
        }
    };

    const resetForm = () => {
        form.reset();
        clearMessages();
        form.removeAttribute("aria-busy");
        form.querySelectorAll(".invalid").forEach(input => input.classList.remove("invalid"));
        form.querySelectorAll("textarea").forEach(textarea => {
            textarea.style.height = "";

            const counter = textarea.nextElementSibling;
            if (counter) {
                counter.textContent = `0 / ${textarea.getAttribute("maxlength")}`;
            }
        });

        if (submitButton) {
            submitButton.disabled = false;
        }

        isSubmitting = false;
    };

    form.querySelectorAll("input, textarea").forEach(field => {
        field.addEventListener("input", () => {
            field.classList.remove("invalid");

            if (field instanceof HTMLTextAreaElement) {
                updateTextarea(field);
            }
        });
    });

    form.addEventListener("submit", async event => {
        event.preventDefault();

        if (isSubmitting || !validateForm()) {
            return;
        }

        isSubmitting = true;
        clearMessages();
        form.setAttribute("aria-busy", "true");

        if (submitButton) {
            submitButton.disabled = true;
        }

        const espUiField = form.querySelector("[data-esp=\"ui\"]");
        if (espUiField) {
            espUiField.value = "1";
        }

        try {
            const response = await fetch(form.action, {
                method: form.method || "POST",
                body: new FormData(form),
                headers: {
                    Accept: "application/json, text/plain, */*",
                },
            });

            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }

            successMessage?.classList.add("display");
        } catch (error) {
            console.error("Demo request failed:", error);

            if (errorMessage) {
                errorMessage.textContent = "We could not send your request. Please try again or call 805-229-1870.";
            }
        } finally {
            const espField = form.querySelector("[data-esp]");
            if (espField) {
                espField.value = "";
            }

            form.removeAttribute("aria-busy");

            if (submitButton) {
                submitButton.disabled = false;
            }

            isSubmitting = false;
        }
    });

    Fancybox.bind(".modal-trigger", {
        Hash: false,
        showClass: "f-fadeIn",
        hideClass: "f-fadeOut",
        on: {
            done: initializeInputMask,
            close: resetForm,
        },
    });
});
